/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_INVITE_USER } from "../graphql";
import { VApplication } from "../../../application";
import config from "../config/useremail.config.json";
import config1 from "../config/userLists.config.json";
import config2 from "../config/inviteTable.config.json";
import { ManageOpenRegistraionService } from "..";
import { pretty } from "@vlinder-web/utils-react";
const is = require("is_js");

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IGetInviteUserMethods extends IPluginMethodMap {
  getInviteUserProps(args: any): Promise<any>;
}

const getSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync(
    "services.ManageOpenRegistraionService"
  ) as ManageOpenRegistraionService;
};
export class GetInviteUserService implements IAgentPlugin {
  readonly methods: IGetInviteUserMethods;

  constructor() {
    this.methods = {
      getInviteUserProps: this.getInviteUserProps.bind(this),
    };
  }

  async getInviteUserProps(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    const filter = {
      openRegID: config?.openRegId,
    };
    console.log("user email======", config?.openRegId);

    try {
      if (client) {
        const res = await client.query({
          query: GET_INVITE_USER,
          variables: {
            filter: filter,
          },
          fetchPolicy: "network-only",
        });

        if (res?.data) {
          const result = this.formatTable(res?.data?.getOpenInvite)
          let payload = res?.data?.getOpenInvite;
          const rowResult = this.getFormat(payload);

          return {
            ...config2,
            response: res?.data,
            modalData: this.formatModal(res?.data),
            // ultUsers: await this.formatCount(res?.data),
            ultUsers: rowResult,
            // users: result?.column,
            // tableHeader: result?.headers,
            modal: result?.output
            // costume: await this.tableHeaders(
            //   res?.data?.getOpenInvite[0]?.presentation?.id
            // ),
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }

  private getFormat(payload: any) {
    let rows: any[] = [];
    let i = 0;
    payload.forEach((item: any) => {
      console.log("item==>", pretty(item))
      let not_purchased = (item?.referalUsed ?? 0) - (item?.purchased ?? 0);
      let rem = (item?.maxInvites ?? 0) - (item?.referalUsed ?? 0);
      rows.push({
        key: i++,
        presentation: item?.presentation?.name,
        presentationId: item?.presentation?.id,
        sections: "-",
        sectionsId: (item?.sections[0]?.id && item?.sections[0]?.id !== null) ? item?.sections[0]?.id : "",
        partition: item?.partition !== null ? item?.partition : "-",
        sectionOptType:
          (item?.sectionOptType[0]?.name && item?.sectionOptType[0]?.name !== null) ? item?.sectionOptType[0]?.name : "-",
        maxInvites: item?.maxInvites ?? 0,
        invitesUsed: item?.referalUsed ?? 0,
        purchased: item?.purchased ?? 0,
        not_purchased: not_purchased > 0 ? not_purchased : 0,
        remaining: rem > 0 ? rem : 0,
      });
    });
    console.log("item==>", pretty(rows))
    return rows;
  }
  private formatTable = (data?: any[]) => {
    let sec: any[] = [];
    data && data.forEach((item: any) => {
      if (item?.sectionOptType[0]?.name !== undefined) {
        sec.push(item?.sectionOptType[0]?.name)
      }
    });
    let uniSec = Array.from(new Set(sec));
    let out: any[] = [], _partition: any = "", col: any[] = [];
    uniSec && uniSec.forEach((sec: any) => {
      let max = 0, used = 0, partition = "", presentation = "";
      data && data.forEach((item: any) => {
        if (sec === item?.sectionOptType[0]?.name) {
          used += item?.referalUsed;
          max += item?.maxInvites;
        }
        presentation = item?.presentation?.id;
        partition = item?.partition;
        _partition = item?.partition;
      });
      col.push(max - used ?? 0);
      out.push({
        presentation: presentation,
        partition: partition,
        sectionOptType: sec,
        maxInvites: max,
        referalUsed: used,
      })
    })
    col.unshift(_partition)
    uniSec.unshift("Partition")
    return ({ output: out, partition: _partition, headers: uniSec, column: col })

  }

  private formatModal(data?: any) {
    let inviteCount: any = [];
    let arr_modal = data?.getOpenInvite;
    let fL_rem = 0,
      fl_max = 0,
      bl_rem = 0,
      bl_max = 0,
      male_rem = 0,
      male_max = 0,
      fem_rem = 0,
      fem_max = 0;
    if (arr_modal.length > 0) {
      for (let i = 0; i < arr_modal.length; i++) {
        let value =
          arr_modal[i]?.sectionOptType.length > 0
            ? arr_modal[i]?.sectionOptType[0].name
            : null;
        // console.log("value======", value);
        if (value && value.toLowerCase() === "frontline") {
          fl_max = fl_max + arr_modal[i]?.maxInvites;

          fL_rem = fL_rem + arr_modal[i]?.referalUsed;

          console.log(
            "frontline=== ",
            arr_modal[i]?.maxInvites,
            fl_max,
            arr_modal[i]?.referalUsed,
            fL_rem
          );
        }
        if (value && value.toLowerCase() === "backline") {
          bl_max = bl_max + arr_modal[i]?.maxInvites;

          bl_rem = bl_rem + arr_modal[i]?.referalUsed;
          console.log(
            "backline=== ",
            arr_modal[i]?.maxInvites,
            bl_max,
            arr_modal[i]?.referalUsed,
            bl_rem
          );
        }
        if (value && value?.toLowerCase() === "male") {
          male_max += arr_modal[i]?.maxInvites;

          male_rem = male_rem + arr_modal[i]?.referalUsed;
        }
        if (value && value?.toLowerCase() === "female") {
          fem_max = fem_max + arr_modal[i]?.maxInvites;

          fem_rem = fem_rem + arr_modal[i]?.referalUsed;
          console.log(
            "female=== ",
            arr_modal[i]?.maxInvites,
            fem_max,
            arr_modal[i]?.referalUsed,
            fem_rem
          );
        }
      }
    }

    inviteCount.push({
      fL_rem: fL_rem,
      fl_max: fl_max,
      bl_rem: bl_rem,
      bl_max: bl_max,
      male_rem: male_rem,
      male_max: male_max,
      fem_max: fem_max,
      fem_rem: fem_rem,
    });
    return inviteCount;
  }
  //64c176075dff8d08f00eed16
  //64c176075dff8d08f00eed16
}
